// src/components/Layout/Navbar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Navbar, Nav, Container, Button, Badge, Dropdown } from 'react-bootstrap';
import { LogOut, User, Crown, Briefcase, Target } from 'lucide-react';

const AppNavbar = () => {
  const { user, profile, signOut } = useAuth();

  const isPremium =
    profile?.subscription_tier === 'premium' &&
    new Date(profile?.subscription_expires_at) > new Date();

  return (
    <Navbar bg="white" expand="lg" className="app-navbar shadow-sm border-bottom" fixed="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2">
          <img
            src="/logo.png"
            alt="Fast Global Resume Logo"
            className="logo-image"
          />
          <span className="brand-text" style={{ fontSize: '1.2rem' }}>
            Fast Global Resume
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto align-items-lg-center gap-2">
            <Nav.Link as={Link} to="/" className="nav-item-link">Home</Nav.Link>
            <Nav.Link as={Link} to="/templates" className="nav-item-link">Templates</Nav.Link>
            <Nav.Link as={Link} to="/pricing" className="nav-item-link">Pricing</Nav.Link>
            <Nav.Link as={Link} to="/about" className="nav-item-link">About</Nav.Link>
            <Nav.Link as={Link} to="/contact" className="nav-item-link">Contact</Nav.Link>

            <Nav.Link as={Link} to="/jobs" className="nav-item-link d-flex align-items-center gap-1">
              <Briefcase size={16} /> Jobs
            </Nav.Link>

            {/* Features Dropdown — always visible */}
            <Dropdown as={Nav.Item} className="d-flex align-items-center">
              <Dropdown.Toggle
                as={Nav.Link}
                className="nav-item-link d-flex align-items-center gap-1"
                id="features-dropdown"
              >
                Features
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item as={Link} to="/jd-matching" className="d-flex align-items-center">
                  <Target size={16} className="me-2" />
                  ATS Job Matching
                  <span className="badge-active ms-2">Active</span>
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/job-tracker" className="d-flex align-items-center">
                  <Briefcase size={16} className="me-2" />
                  Job Tracker
                  <span className="badge-active ms-2">Active</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {user ? (
              <>
                {isPremium && (
                  <Badge bg="warning" className="d-flex align-items-center gap-1 ms-2">
                    <Crown size={12} /> Premium
                  </Badge>
                )}
                <Nav.Link as={Link} to="/dashboard" className="nav-item-link d-flex align-items-center gap-1">
                  <User size={16} /> Dashboard
                </Nav.Link>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={signOut}
                  className="d-flex align-items-center gap-1"
                >
                  <LogOut size={16} /> Logout
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login" className="nav-item-link">Sign In</Nav.Link>
                <Button as={Link} to="/signup" size="sm" className="btn-hero-primary">
                  Sign Up
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;